const config = {
    s3: {
        REGION: process.env.REACT_APP_REGION,
        BUCKET: process.env.REACT_APP_BUCKET,
    },
    cognito: {
        REGION: process.env.REACT_APP_REGION,
        USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
        APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
        IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
    },
    apiGateway: {
        REGION: process.env.REACT_APP_REGION,
        URL_APPRENTISSAGE: process.env.REACT_APP_API_APPRENTISSAGE_URL,
        URL_CDM_GLOBAL: process.env.REACT_APP_API_CDM_GLOBAL_URL,
        URL_SCRB: process.env.REACT_APP_API_SCRB_URL,
    }
};

/*const config ={
    s3: {
        REGION: "eu-central-1",
        BUCKET: "dev-cdm-extranet-storage-exchangebucket85049a57-1x3ho8kwwlr7"
    },
    cognito: {
        REGION: "eu-central-1",
        USER_POOL_ID: "eu-central-1_J2zOgbx6p",
        APP_CLIENT_ID: "2sq3ltkqt2tcj3a06a9mf93pr6"
    },
    apiGateway: {
        REGION: "eu-central-1",
        URL_APPRENTISSAGE: "https://mg7o0y32t5.execute-api.eu-central-1.amazonaws.com",
        URL_CDM_GLOBAL: "https://3j21elphc4.execute-api.eu-central-1.amazonaws.com",
        URL_SCRB: "https://r54g8kn5tg.execute-api.eu-central-1.amazonaws.com"
    }
}*/

export default config;  